import { useEffect, useState } from 'react';
import { api, mediaUrl, formatMoney } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Input } from '@/components/ui/input';
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from '@/components/ui/select';
import { Star, StarOff, Ban, Trash2 } from 'lucide-react';
import { toast } from 'sonner';

export default function AdminAds() {
    const [ads, setAds] = useState([]);
    const [q, setQ] = useState('');
    const [status, setStatus] = useState('all');

    const load = async () => {
        const params = {};
        if (q) params.q = q;
        if (status !== 'all') params.status = status;
        const { data } = await api.get('/admin/ads', { params });
        setAds(data);
    };
    useEffect(() => { load(); /* eslint-disable-next-line */ }, [q, status]);

    const setAdStatus = async (id, s) => { await api.put(`/admin/ads/${id}`, { status: s }); toast.success('Actualizado'); load(); };
    const toggleFeatured = async (a) => { await api.put(`/admin/ads/${a.id}`, { featured: !a.featured }); load(); };
    const del = async (id) => { if (!window.confirm('¿Eliminar anuncio?')) return; await api.delete(`/admin/ads/${id}`); toast.success('Eliminado'); load(); };

    return (
        <div className="space-y-4">
            <div className="flex items-baseline justify-between flex-wrap gap-3">
                <div>
                    <h1 className="text-2xl font-semibold tracking-tight">Anuncios</h1>
                    <p className="text-sm text-muted-foreground">Moderación y gestión de anuncios.</p>
                </div>
                <div className="flex items-center gap-2">
                    <Input placeholder="Buscar…" value={q} onChange={(e) => setQ(e.target.value)} className="w-56" data-testid="ads-search" />
                    <Select value={status} onValueChange={setStatus}>
                        <SelectTrigger className="w-40" data-testid="ads-status-filter"><SelectValue /></SelectTrigger>
                        <SelectContent>
                            <SelectItem value="all">Todos</SelectItem>
                            <SelectItem value="published">Publicados</SelectItem>
                            <SelectItem value="paused">Pausados</SelectItem>
                            <SelectItem value="rejected">Rechazados</SelectItem>
                            <SelectItem value="sold">Vendidos</SelectItem>
                        </SelectContent>
                    </Select>
                </div>
            </div>
            <div className="rounded-xl border bg-card overflow-x-auto">
                <table className="w-full text-sm">
                    <thead className="text-xs text-muted-foreground text-left border-b"><tr>
                        <th className="p-3">Anuncio</th><th>Vendedor</th><th>Precio</th><th>Estado</th><th>Vistas</th><th></th>
                    </tr></thead>
                    <tbody data-testid="admin-ads-table">
                        {ads.map(a => (
                            <tr key={a.id} className="border-b">
                                <td className="p-3">
                                    <div className="flex items-center gap-3">
                                        <div className="h-12 w-12 rounded-md overflow-hidden bg-[hsl(var(--ok-surface-2))]">
                                            {a.media?.[0]?.url ? <img src={mediaUrl(a.media[0].url)} alt="" className="h-full w-full object-cover" /> : null}
                                        </div>
                                        <div className="min-w-0">
                                            <div className="font-medium truncate max-w-[220px]">{a.title}</div>
                                            <div className="text-xs text-muted-foreground">{a.category_slug}</div>
                                        </div>
                                    </div>
                                </td>
                                <td className="p-3">@{a.seller_nickname}</td>
                                <td className="p-3 tabular-nums">{formatMoney(a.price, a.currency)}</td>
                                <td className="p-3"><Badge variant="secondary" className="capitalize">{a.status}</Badge> {a.featured && <Badge className="ml-1">Destacado</Badge>}</td>
                                <td className="p-3 tabular-nums">{a.views}</td>
                                <td className="p-3 text-right">
                                    <div className="inline-flex gap-2">
                                        <Button size="sm" variant="outline" onClick={() => toggleFeatured(a)}>{a.featured ? <StarOff className="h-3 w-3" /> : <Star className="h-3 w-3" />}</Button>
                                        <Select value={a.status} onValueChange={(v) => setAdStatus(a.id, v)}>
                                            <SelectTrigger className="h-8 w-32"><SelectValue /></SelectTrigger>
                                            <SelectContent>
                                                <SelectItem value="published">Publicar</SelectItem>
                                                <SelectItem value="paused">Pausar</SelectItem>
                                                <SelectItem value="rejected">Rechazar</SelectItem>
                                            </SelectContent>
                                        </Select>
                                        <Button size="sm" variant="outline" onClick={() => del(a.id)}><Trash2 className="h-3 w-3" /></Button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
